export default __webpack_public_path__ + "static/GRID2022-Stock-Conflict-light-a95f16c176f61240d1b3773bed479c91.jpg";